export const twin = (value) => {
  return value ? JSON.parse(JSON.stringify(value)) : value;
};
